import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";
import ImageSvg from "../ui/image-svg";

export const HeroAboutSection = () => {
  return (
    <section className="py-8 md:py-16 min-h-screen bg-n-bg-1">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-0 gap-10 items-center">
          <div className="order-1 z-10 px-4">
            <p className="text-lg text-n-green font-semibold lg:mb-8 mb-4">
              &gt; Quem somos
            </p>
            <h1
              className="mb-6 text-4xl font-normal text-n-text-green md:text-[56px]"
              style={{ fontFamily: "'Anton', sans-serif", lineHeight: "1.2em" }}
            >
              Facilidade e segurança no transporte de veículo
            </h1>
            <div className="hidden md:flex md:gap-6 gap-1 mb-6">
              <div className="flex gap-1 items-center border rounded-full border-n-neutral-lighter py-1 px-3 h-[34px]">
                <img src="/icons/reclameaqui.png" alt="Reclame aqui" />
                <p className="text-n-text-neutral font-medium text-xs">
                  Somos nota máxima no Reclame Aqui!
                </p>
              </div>
              <div className="flex gap-1 items-center border rounded-full border-n-neutral-lighter py-1 px-3 h-[34px]">
                <img src="/icons/icoGG.png" alt="google" />
                <p className="text-n-text-neutral font-medium text-xs flex items-center gap-1.5">
                  <FaStar className="text-n-text-neutral w-3 h-3" /> 5 estrelas
                  no Google!
                </p>
              </div>
            </div>
            <p className="text-lg text-n-text-neutral mb-6 max-w-xl">
              Conectamos você a transportadoras confiáveis, garantindo a entrega
              do seu veículo com total segurança e eficiência. Descubra uma nova
              forma de transportar seu carro, sem complicações.
            </p>
            <Link to="/fazer-cotacao">
              <Button variant="default">
                Agendar meu transporte
                <ArrowRight className="ml-2 " />
              </Button>
            </Link>
          </div>

          <div className="order-2 relative">
            <div className="relative z-1">
              <ImageSvg
                src="concept.svg"
                alt="Mulher fazendo cotação de transporte de veículo pelo celular"
                className="w-full h-auto "
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
